import { Check, Play, Sparkles } from "lucide-react";

export default function TdsReportsWelcome({
  onStart,
  title = "Tax Deducted at Source (TDS)",
  description = "Generate statutory TDS reports compliant with the latest Indian Income Tax rules. Start here — filters and reports appear only when you need them.",
  supported = [
    "Monthly Register",
    "Employee Tax Computation",
    "Quarterly Return (Form 24Q)",
    "Form 16",
    "Reconciliation",
    "Employee Tax Ledger",
    "Annual Projection",
  ],
  ctaLabel = "Start Report Generation",
}) {
  return (
    <section className="tdsr-welcome">
      <div className="tdsr-welcome__icon" aria-hidden="true">
        <Sparkles size={28} />
      </div>
      <h2 className="tdsr-welcome__title">{title}</h2>
      <p className="tdsr-welcome__desc">{description}</p>
      <ul className="tdsr-welcome__list">
        {supported.map((item) => (
          <li key={item}>
            <Check size={16} strokeWidth={2.5} />
            {item}
          </li>
        ))}
      </ul>
      <button type="button" className="tds-btn tds-btn--primary tdsr-welcome__cta" onClick={onStart}>
        <Play size={16} />
        {ctaLabel}
      </button>
    </section>
  );
}
